import Svg, { Use, SvgProps, Defs, Path, G } from "react-native-svg"
import { useTheme } from "styled-rn"

export const LogoWave = (props: SvgProps) => {
  const theme = useTheme()

  return (
    <Svg viewBox="0 0 300 300" {...props}>
      <Defs>
        <G id="LogoWave-puzmowavescene_0.19" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer1_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer1_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.21" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer2_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer2_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.23" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer3_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer3_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.25" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer4_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer4_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.65" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer5_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer5_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.67" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer6_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer6_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.69" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer7_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer7_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.71" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer8_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.73" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer9_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_1.25" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer10_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_1.65" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer11_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer11_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_1.67" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer12_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer12_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_1.69" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer13_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer13_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_1.71" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer14_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer14_0_1_STROKES" />
            <Use xlinkHref="#LogoWave-Layer14_0_2_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_1.73" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer15_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer15_0_1_STROKES" />
            <Use xlinkHref="#LogoWave-Layer15_0_2_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.0" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer16_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer16_0_1_STROKES" />
            <Use xlinkHref="#LogoWave-Layer16_0_2_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.19" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer17_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer17_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.21" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer18_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer18_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.23" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer19_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer19_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.25" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer20_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.27" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer21_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.29" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer22_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.31" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer23_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.33" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer24_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.35" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer25_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.37" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer26_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.39" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer27_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.41" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer28_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.43" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer29_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.45" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer30_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.47" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer31_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.49" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer32_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.51" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer33_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.53" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer34_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.55" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer35_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.57" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer36_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.59" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer37_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.61" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer38_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.63" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer39_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_2.73" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer40_0_FILL" />
            <Use xlinkHref="#LogoWave-Layer40_0_1_STROKES" />
            <Use xlinkHref="#LogoWave-Layer40_0_2_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescenet18d71" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.73" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.775;.789;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.63" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.634;.662;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.61" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.606;.634;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.59" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.577;.606;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.57" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.549;.577;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.55" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.521;.549;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.53" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.493;.521;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.51" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.465;.493;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.49" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.437;.465;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.47" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.408;.437;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.45" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.38;.408;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.43" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.352;.38;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.41" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.324;.352;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.39" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.296;.324;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.37" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.268;.296;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.35" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.239;.268;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.33" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.211;.239;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.31" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.183;.211;.972;1"
              values="none;inline;none;inline;inline"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.29" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.155;.183;.944;.972;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.27" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.127;.155;.915;.944;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.25" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.099;.127;.887;.915;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.23" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.07;.099;.859;.887;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.21" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.042;.07;.831;.859;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.19" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.014;.042;.803;.831;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G>
            <Use xlinkHref="#LogoWave-puzmowavescene_2.0" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.014;.789;.803;1"
              values="inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.73" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.775;.789;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.71" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.746;.775;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.69" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.718;.746;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.67" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.69;.718;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.65" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.662;.69;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.25" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.099;.662;.887;1"
              values="none;inline;none;inline;inline"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.73" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.775;.789;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.71" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.746;.775;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.69" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.718;.746;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.67" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.69;.718;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.65" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.662;.69;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.25" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.099;.662;.887;1"
              values="none;inline;none;inline;inline"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.23" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.07;.099;.859;.887;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.21" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.042;.07;.831;.859;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.19" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.014;.042;.803;.831;1"
              values="none;inline;none;inline;none;none"
            />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.75" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer41_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.78" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer42_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.80" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer43_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.83" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer44_0_1_STROKES" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.86" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer45_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescene_0.88" overflow="visible">
          <G>
            <Use xlinkHref="#LogoWave-Layer46_0_FILL" />
          </G>
        </G>
        <G id="LogoWave-puzmowavescenet74o56d71" overflow="visible">
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_2.73" />
            <animate attributeName="display" repeatCount="1" fill="freeze" dur="2.367s" keyTimes="0;.789;1" values="none;inline;inline" />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_1.73" />
            <animate attributeName="display" repeatCount="1" fill="freeze" dur="2.367s" keyTimes="0;.789;1" values="none;inline;inline" />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.88" />
            <animate attributeName="display" repeatCount="1" fill="freeze" dur="2.367s" keyTimes="0;.986;1" values="none;inline;inline" />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.86" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.958;.986;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.83" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.915;.958;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.80" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.873;.915;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.78" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.845;.873;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.75" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.803;.845;1"
              values="none;inline;none;none"
            />
          </G>
          <G display="none">
            <Use xlinkHref="#LogoWave-puzmowavescene_0.73" />
            <animate
              attributeName="display"
              repeatCount="1"
              fill="freeze"
              dur="2.367s"
              keyTimes="0;.789;.803;1"
              values="none;inline;none;none"
            />
          </G>
        </G>
        <G id="LogoWave-Layer46_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M260.45 534.1Q257.25 532.8 254.3 534.2 251.35 535.6 250.4 538.95 249.45 542.3 251.05 545.6 252.7 548.95 255.85 550.25 259.1 551.65 262 550.2 265 548.8 265.9 545.4 266.85 542.1 265.25 538.75 263.65 535.4 260.45 534.1M219.5 566.6Q220.45 563.3 218.85 559.95 217.25 556.6 214.05 555.3 210.85 554 207.9 555.4 204.95 556.8 204 560.15 203.05 563.5 204.65 566.8 206.3 570.15 209.45 571.45 212.7 572.85 215.6 571.4 218.6 570 219.5 566.6Z"
          />
        </G>
        <G id="LogoWave-Layer45_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M261.2 535.1Q258.1 533.95 255.05 535.2 252 536.45 250.75 539.4 249.5 542.4 250.8 545.3 252.2 548.3 255.25 549.45 258.35 550.65 261.4 549.4 264.5 548.15 265.7 545.15 266.9 542.2 265.6 539.25 264.3 536.25 261.2 535.1M214.9 570.4Q218 569.15 219.2 566.15 220.4 563.2 219.1 560.25 217.8 557.25 214.7 556.1 211.6 554.95 208.55 556.2 205.5 557.45 204.25 560.4 203 563.4 204.3 566.3 205.7 569.3 208.75 570.45 211.85 571.65 214.9 570.4Z"
          />
        </G>
        <G id="LogoWave-Layer43_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M260.45 534.1Q257.25 532.8 254.3 534.2 251.35 535.6 250.4 538.95 249.45 542.3 251.05 545.6 252.7 548.95 255.85 550.25 259.1 551.65 262 550.2 265 548.8 265.9 545.4 266.85 542.1 265.25 538.75 263.65 535.4 260.45 534.1M219.5 566.6Q220.45 563.3 218.85 559.95 217.25 556.6 214.05 555.3 210.85 554 207.9 555.4 204.95 556.8 204 560.15 203.05 563.5 204.65 566.8 206.3 570.15 209.45 571.45 212.7 572.85 215.6 571.4 218.6 570 219.5 566.6Z"
          />
        </G>
        <G id="LogoWave-Layer42_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M261.2 535.1Q258.1 533.95 255.05 535.2 252 536.45 250.75 539.4 249.5 542.4 250.8 545.3 252.2 548.3 255.25 549.45 258.35 550.65 261.4 549.4 264.5 548.15 265.7 545.15 266.9 542.2 265.6 539.25 264.3 536.25 261.2 535.1M214.9 570.4Q218 569.15 219.2 566.15 220.4 563.2 219.1 560.25 217.8 557.25 214.7 556.1 211.6 554.95 208.55 556.2 205.5 557.45 204.25 560.4 203 563.4 204.3 566.3 205.7 569.3 208.75 570.45 211.85 571.65 214.9 570.4Z"
          />
        </G>
        <G id="LogoWave-Layer40_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M184.8 525.15Q172.8 536.2 167.15 549.45 161.7 562.2 161.2 579.25 160.4 611.05 182.75 632.7 183.45 633.35 184.15 634 210.65 655.65 248.9 655.65 283.85 655.75 308.35 633.85 333.4 610.75 334 579 334.15 562.55 327.85 548.95 321.75 535.7 309.6 525.05 283.9 503.4 247.55 504.35 210.7 503.55 184.8 525.15M250.9 576.55Q269.45 568.45 281.3 565.45 285.7 579.55 280.15 589.45 274.6 599.3 263.2 605.55 251.75 611.75 238.05 609.75 224.4 607.8 216.6 595.3 232.3 584.7 250.9 576.55Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M281.3 565.45Q269.45 568.45 250.9 576.55 232.3 584.7 216.6 595.3 224.4 607.8 238.05 609.75 251.75 611.75 263.2 605.55 274.6 599.3 280.15 589.45 285.7 579.55 281.3 565.45Z"
          />
        </G>
        <G id="LogoWave-Layer19_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M169.65 549.85Q162.65 564.6 162.35 578.95 162.05 592.8 168 608.9 173.2 622.85 182.35 632.85 192.65 644.15 207.95 650.4 208.85 650.7 209.7 651.1 242.4 661.2 277.85 646.95 310.3 633.95 324.9 604.55 339.5 573.75 328.15 544.1 324.85 535.65 320.1 528.8 316.15 523.1 311.25 518.5 300.65 508.5 285.4 503.1 253.45 492.7 220.05 507.1 185.6 520.15 169.65 549.85Z"
          />
        </G>
        <G id="LogoWave-Layer18_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M175.3 539.45Q166.15 552.85 163.7 567.1 161.3 580.7 164.75 597.5 169.1 618.55 182.8 632.7 189.3 639.45 197.95 644.6 198.8 645.05 199.55 645.55 230.35 660.55 267.6 651.8 301.6 643.95 320.45 617.05 339.55 588.8 332.9 557.8 330.1 545.45 324.05 535.65 322.2 532.65 320.05 529.9 311.1 518.45 296.8 510.85 266.9 495.65 231.65 504.8 195.6 512.5 175.3 539.45Z"
          />
        </G>
        <G id="LogoWave-Layer17_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M182.55 527.4Q171.05 538.95 166 552.45 161.1 565.4 161.35 582.45 161.85 612.55 182.75 632.7 183.9 633.85 185.15 634.95 185.85 635.55 186.6 636.2 214.05 656.7 252.25 655.05 287.15 653.65 310.7 630.65 334.75 606.5 333.95 574.75 333.5 560.7 328.35 548.95 327.5 546.95 326.5 545.05 319.85 532.05 307.25 521.9 280.6 501.4 244.35 503.9 207.5 504.7 182.55 527.4Z"
          />
        </G>
        <G id="LogoWave-Layer16_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M184.8 525.15Q172.8 536.2 167.15 549.45 161.7 562.2 161.2 579.25 160.4 611.05 182.75 632.7 183.45 633.35 184.15 634 210.65 655.65 248.9 655.65 283.85 655.75 308.35 633.85 333.4 610.75 334 579 334.15 562.55 327.85 548.95 321.75 535.7 309.6 525.05 283.9 503.4 247.55 504.35 210.7 503.55 184.8 525.15M209.45 571.45Q206.3 570.15 204.65 566.8 203.05 563.5 204 560.15 204.95 556.8 207.9 555.4 210.85 554 214.05 555.3 217.25 556.6 218.85 559.95 220.45 563.3 219.5 566.6 218.6 570 215.6 571.4 212.7 572.85 209.45 571.45M250.4 538.95Q251.35 535.6 254.3 534.2 257.25 532.8 260.45 534.1 263.65 535.4 265.25 538.75 266.85 542.1 265.9 545.4 265 548.8 262 550.2 259.1 551.65 255.85 550.25 252.7 548.95 251.05 545.6 249.45 542.3 250.4 538.95M250.9 576.55Q269.45 568.45 281.3 565.45 285.7 579.55 280.15 589.45 274.6 599.3 263.2 605.55 251.75 611.75 238.05 609.75 224.4 607.8 216.6 595.3 232.3 584.7 250.9 576.55Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M281.3 565.45Q269.45 568.45 250.9 576.55 232.3 584.7 216.6 595.3 224.4 607.8 238.05 609.75 251.75 611.75 263.2 605.55 274.6 599.3 280.15 589.45 285.7 579.55 281.3 565.45M254.3 534.2Q251.35 535.6 250.4 538.95 249.45 542.3 251.05 545.6 252.7 548.95 255.85 550.25 259.1 551.65 262 550.2 265 548.8 265.9 545.4 266.85 542.1 265.25 538.75 263.65 535.4 260.45 534.1 257.25 532.8 254.3 534.2M204.65 566.8Q206.3 570.15 209.45 571.45 212.7 572.85 215.6 571.4 218.6 570 219.5 566.6 220.45 563.3 218.85 559.95 217.25 556.6 214.05 555.3 210.85 554 207.9 555.4 204.95 556.8 204 560.15 203.05 563.5 204.65 566.8Z"
          />
        </G>
        <G id="LogoWave-Layer15_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M281.35 565.45Q269.5 568.45 250.95 576.55 232.35 584.7 216.65 595.3 224.45 607.8 238.1 609.75 251.8 611.75 263.25 605.55 274.65 599.3 280.2 589.45 285.75 579.55 281.35 565.45Z"
          />
        </G>
        <G id="LogoWave-Layer14_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M184.85 525.15Q172.85 536.2 167.2 549.45 161.75 562.2 161.25 579.25 160.45 611.05 182.8 632.7 183.5 633.35 184.2 634 210.7 655.65 248.95 655.65 283.9 655.75 308.4 633.85 333.45 610.75 334.05 579 334.2 562.75 328.05 549.3 328 549.1 327.9 548.95 321.8 535.7 309.65 525.05 283.95 503.4 247.6 504.35 210.75 503.55 184.85 525.15M250.95 576.55Q269.5 568.45 281.35 565.45 285.75 579.55 280.2 589.45 274.65 599.3 263.25 605.55 251.8 611.75 238.1 609.75 224.45 607.8 216.65 595.3 232.35 584.7 250.95 576.55Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M281.35 565.45Q269.5 568.45 250.95 576.55 232.35 584.7 216.65 595.3 224.45 607.8 238.1 609.75 251.8 611.75 263.25 605.55 274.65 599.3 280.2 589.45 285.75 579.55 281.35 565.45Z"
          />
        </G>
        <G id="LogoWave-Layer13_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M182.6 527.4Q171.1 538.95 166.05 552.45 161.15 565.4 161.4 582.45 161.9 612.55 182.8 632.7 183.95 633.85 185.2 634.95 185.9 635.55 186.65 636.2 214.1 656.7 252.3 655.05 287.2 653.65 310.75 630.65 334.8 606.5 334 574.75 333.5 560.4 328.2 548.5 327.45 546.75 326.55 545.05 319.9 532.05 307.3 521.9 280.65 501.4 244.4 503.9 207.55 504.7 182.6 527.4Z"
          />
        </G>
        <G id="LogoWave-Layer12_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M175.25 539.45Q166.1 552.85 163.65 567.1 161.25 580.7 164.7 597.5 169.05 618.55 182.75 632.7 189.25 639.45 197.9 644.6 198.75 645.05 199.5 645.55 230.3 660.55 267.55 651.8 301.55 643.95 320.4 617.05 339.5 588.8 332.85 557.8 330.3 546.6 325.1 537.5 322.8 533.5 320 529.9 311.05 518.45 296.75 510.85 266.85 495.65 231.6 504.8 195.55 512.5 175.25 539.45Z"
          />
        </G>
        <G id="LogoWave-Layer11_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M169.65 549.85Q162.65 564.6 162.35 578.95 162.05 592.8 168 608.9 173.2 622.85 182.35 632.85 192.65 644.15 207.95 650.4 208.85 650.7 209.7 651.1 242.4 661.2 277.85 646.95 310.3 633.95 324.9 604.55 339.5 573.75 328.15 544.1 324.6 535.05 319.4 527.8 315.75 522.7 311.25 518.5 300.65 508.5 285.4 503.1 253.45 492.7 220.05 507.1 185.6 520.15 169.65 549.85Z"
          />
        </G>
        <G id="LogoWave-Layer10_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M168.55 552.95Q162.15 567.9 162.4 582.3 162.65 596.2 169.2 611.95 181.5 641.3 210.75 651.9 211.7 652.2 212.6 652.5 245.6 661.35 280.5 645.7 312.4 631.5 325.8 601.5 339.2 570.15 326.7 541 320.1 525.9 308.8 516.05 297.85 506.45 282.4 501.7 250.1 492.55 217.3 508.25 183.4 522.65 168.55 552.95Z"
          />
        </G>
        <G id="LogoWave-Layer9_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M254.3 534.2Q251.35 535.6 250.4 538.95 249.45 542.3 251.05 545.6 252.7 548.95 255.85 550.25 259.1 551.65 262 550.2 265 548.8 265.9 545.4 266.85 542.1 265.25 538.75 263.65 535.4 260.45 534.1 257.25 532.8 254.3 534.2M215.6 571.4Q218.6 570 219.5 566.6 220.45 563.3 218.85 559.95 217.25 556.6 214.05 555.3 210.85 554 207.9 555.4 204.95 556.8 204 560.15 203.05 563.5 204.65 566.8 206.3 570.15 209.45 571.45 212.7 572.85 215.6 571.4Z"
          />
        </G>
        <G id="LogoWave-Layer8_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M254.3 534.2Q251.35 535.6 250.4 538.95 249.45 542.3 251.05 545.6 252.7 548.95 255.85 550.25 259.1 551.65 262 550.2 265 548.8 265.9 545.4 266.85 542.1 265.25 538.75 263.65 535.4 260.45 534.1 257.25 532.8 254.3 534.2M215.6 571.4Q218.6 570 219.5 566.6 220.45 563.3 218.85 559.95 217.25 556.6 214.05 555.3 210.85 554 207.9 555.4 204.95 556.8 204 560.15 203.05 563.5 204.65 566.8 206.3 570.15 209.45 571.45 212.7 572.85 215.6 571.4Z"
          />
        </G>
        <G id="LogoWave-Layer7_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M279.8 560.45Q267.9 564.55 249.6 574.55 231.25 584.6 216.1 596.9 225.2 609 239.4 609.75 253.6 610.55 264.8 603.2 275.95 595.75 280.75 585.15 285.55 574.5 279.8 560.45M262.9 541.95Q263.55 538.55 261.7 535.35 259.8 532.15 256.5 531.1 253.2 530.1 250.45 531.7 247.6 533.35 246.9 536.75 246.25 540.2 248.1 543.35 250.05 546.55 253.25 547.55 256.6 548.7 259.4 547 262.25 545.35 262.9 541.95M217.9 566.85Q218.55 563.45 216.7 560.3 214.8 557.1 211.5 556.05 208.2 555 205.4 556.65 202.6 558.3 201.9 561.7 201.2 565.1 203.1 568.25 205 571.5 208.3 572.5 211.6 573.65 214.35 571.95 217.25 570.3 217.9 566.85Z"
          />
        </G>
        <G id="LogoWave-Layer6_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M282.1 575.9Q285.35 563.65 276.8 549.5 264.9 555.95 247.25 569.8 229.6 583.65 215.7 599.4 227.45 610.9 242.6 609.35 257.8 607.85 268.35 598 278.85 588.15 282.1 575.9M198.9 564.95Q198.9 568.4 201.4 571.1 203.95 573.9 207.3 574.25 210.8 574.6 213.2 572.4 215.7 570.2 215.6 566.7 215.55 563.25 213.05 560.5 210.6 557.75 207.1 557.4 203.7 557.1 201.25 559.25 198.85 561.45 198.9 564.95M239.3 533.1Q239.35 536.6 241.8 539.3 244.35 542 247.7 542.35 251.25 542.8 253.6 540.55 256.1 538.35 255.95 534.85 255.95 531.4 253.45 528.7 250.95 525.95 247.55 525.6 244.05 525.25 241.65 527.45 239.2 529.65 239.3 533.1Z"
          />
        </G>
        <G id="LogoWave-Layer5_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M271.6 593.75Q282.4 582.05 284.9 568.45 287.5 554.75 276.85 540.15 264.25 548.25 245.95 564.95 227.55 581.7 213.5 600.15 227.5 611.6 244.1 608.55 260.8 605.45 271.6 593.75M196.05 565.9Q196.25 569.4 198.8 571.95 201.4 574.65 204.85 574.9 208.35 575.15 210.6 572.85 213 570.55 212.75 567.05 212.6 563.6 210.05 560.95 207.45 558.3 204 558.1 200.55 557.9 198.2 560.15 195.9 562.4 196.05 565.9M235.95 537.55Q238.55 540.15 242 540.4 245.5 540.65 247.75 538.35 250.15 536.05 249.9 532.55 249.75 529.15 247.2 526.5 244.55 523.85 241.15 523.6 237.7 523.4 235.35 525.7 233 527.95 233.15 531.45 233.35 534.9 235.95 537.55Z"
          />
        </G>
        <G id="LogoWave-Layer4_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M272.1 593.25Q282.8 581.05 285.1 567.1 287.45 553.15 276.3 538.4 263.6 547 245.25 564.4 226.9 581.95 212.95 601.1 227.45 612.45 244.35 608.95 261.3 605.45 272.1 593.25M194.9 566.65Q195.2 570.15 197.8 572.7 200.5 575.3 203.9 575.4 207.4 575.65 209.65 573.25 212 570.95 211.7 567.45 211.45 564 208.8 561.4 206.2 558.8 202.7 558.7 199.25 558.55 196.95 560.85 194.65 563.2 194.9 566.65M234.2 536.9Q236.85 539.5 240.25 539.7 243.8 539.9 246.05 537.55 248.35 535.15 248.05 531.65 247.85 528.25 245.2 525.65 242.55 523.05 239.1 522.9 235.65 522.8 233.35 525.1 231.05 527.4 231.3 530.9 231.55 534.35 234.2 536.9Z"
          />
        </G>
        <G id="LogoWave-Layer3_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M271.6 593.75Q282.4 582.05 284.9 568.45 287.5 554.75 276.85 540.15 264.25 548.25 245.95 564.95 227.55 581.7 213.5 600.15 227.5 611.6 244.1 608.55 260.8 605.45 271.6 593.75M196.05 565.9Q196.25 569.4 198.8 571.95 201.4 574.65 204.85 574.9 208.35 575.15 210.6 572.85 213 570.55 212.75 567.05 212.6 563.6 210.05 560.95 207.45 558.3 204 558.1 200.55 557.9 198.2 560.15 195.9 562.4 196.05 565.9M235.95 537.55Q238.55 540.15 242 540.4 245.5 540.65 247.75 538.35 250.15 536.05 249.9 532.55 249.75 529.15 247.2 526.5 244.55 523.85 241.15 523.6 237.7 523.4 235.35 525.7 233 527.95 233.15 531.45 233.35 534.9 235.95 537.55Z"
          />
        </G>
        <G id="LogoWave-Layer2_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M282.1 575.9Q285.35 563.65 276.8 549.5 264.9 555.95 247.25 569.8 229.6 583.65 215.7 599.4 227.45 610.9 242.6 609.35 257.8 607.85 268.35 598 278.85 588.15 282.1 575.9M198.9 564.95Q198.9 568.4 201.4 571.1 203.95 573.9 207.3 574.25 210.8 574.6 213.2 572.4 215.7 570.2 215.6 566.7 215.55 563.25 213.05 560.5 210.6 557.75 207.1 557.4 203.7 557.1 201.25 559.25 198.85 561.45 198.9 564.95M239.3 533.1Q239.35 536.6 241.8 539.3 244.35 542 247.7 542.35 251.25 542.8 253.6 540.55 256.1 538.35 255.95 534.85 255.95 531.4 253.45 528.7 250.95 525.95 247.55 525.6 244.05 525.25 241.65 527.45 239.2 529.65 239.3 533.1Z"
          />
        </G>
        <G id="LogoWave-Layer1_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M279.85 560.45Q267.95 564.55 249.65 574.55 231.3 584.6 216.15 596.9 225.25 609 239.45 609.75 253.65 610.55 264.85 603.2 276 595.75 280.8 585.15 285.6 574.5 279.85 560.45M262.95 541.95Q263.6 538.55 261.75 535.35 259.85 532.15 256.55 531.1 253.25 530.1 250.5 531.7 247.65 533.35 246.95 536.75 246.3 540.2 248.15 543.35 250.1 546.55 253.3 547.55 256.65 548.7 259.45 547 262.3 545.35 262.95 541.95M214.4 571.95Q217.3 570.3 217.95 566.85 218.6 563.45 216.75 560.3 214.85 557.1 211.55 556.05 208.25 555 205.45 556.65 202.65 558.3 201.95 561.7 201.25 565.1 203.15 568.25 205.05 571.5 208.35 572.5 211.65 573.65 214.4 571.95Z"
          />
        </G>
        <Path
          id="LogoWave-Layer44_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="6"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M206.75 566.95L218 561.4M253 545.7L264.25 540.15"
        />
        <Path
          id="LogoWave-Layer41_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="6"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M206.75 566.95L218 561.4M253 545.7L264.25 540.15"
        />
        <Path
          id="LogoWave-Layer40_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M216.6 595.3Q232.3 584.7 250.9 576.55 269.45 568.45 281.3 565.45 285.7 579.55 280.15 589.45 274.6 599.3 263.2 605.55 251.75 611.75 238.05 609.75 224.4 607.8 216.6 595.3Z"
        />
        <Path
          id="LogoWave-Layer40_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M327.85 548.95Q338.35 539.85 340.35 533.75 342.05 528.55 337.25 522 334.1 517.65 333.3 516.35 331.3 512.85 330.85 509.35 329.75 500.1 339.45 486.6M182.75 632.7Q176.5 637.6 172.55 643.3 168.55 649.1 167.45 654.8 166 662.65 178.55 663.7 185.55 664.25 200.15 663.4"
        />
        <Path
          id="LogoWave-Layer39_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7M311.1 526.15Q330.65 514.65 333.1 501.65 335.45 489.9 324.8 468.8"
        />
        <Path
          id="LogoWave-Layer38_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7M307.2 526.65Q328.4 511.55 329.45 498.15 330.55 484.5 311.15 471.1"
        />
        <Path
          id="LogoWave-Layer37_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M310.2 522.5Q328.35 503.8 317.15 488.9 313.35 483.85 305.35 478.2 296.65 472.5 293.65 470.1M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7"
        />
        <Path
          id="LogoWave-Layer36_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M311.2 523Q321.65 511.9 323.15 504.4 324.35 498.45 319.95 492.35 313.6 485.15 310.3 480.65 304.4 472.5 303.15 463.1M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7"
        />
        <Path
          id="LogoWave-Layer35_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M311.25 525Q322.9 517.15 324.9 510.75 326.3 506.2 322.85 499.2 318 489.5 317.15 485.55 315.2 476.15 320 465.05M181.55 632.9Q180.35 633.65 179.2 634.4 172.65 638.85 168.3 644.3 163.9 649.8 162.4 655.45 158.95 668.7 192.2 671.7"
        />
        <Path
          id="LogoWave-Layer34_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M304.65 531.15Q308.6 529.7 311.8 528.25 324.5 522.6 328.1 517.3 331.25 512.8 328.5 505.15 326.75 500.1 326.4 498.55 325.45 494.7 326.1 491.2 327.65 482.05 340.8 471.85M181.55 632.85Q180.35 633.6 179.2 634.35 172.65 638.8 168.3 644.25 163.9 649.75 162.4 655.4 158.95 668.65 192.2 671.65"
        />
        <Path
          id="LogoWave-Layer33_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7M312.75 531.3Q325.25 526.8 330.65 520.85 334.65 516.5 336.2 509.1 338.75 496.85 339.15 495.8 341.95 487.55 349.2 480.65"
        />
        <Path
          id="LogoWave-Layer32_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.85Q180.3 633.6 179.15 634.35 172.6 638.8 168.25 644.25 163.85 649.75 162.35 655.4 158.9 668.65 192.15 671.65M313.1 528.55Q333.65 519.1 337.45 506.35 340.9 494.9 332.4 472.85"
        />
        <Path
          id="LogoWave-Layer31_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7M307.2 526.65Q328.4 511.55 329.45 498.15 330.55 484.5 311.15 471.1"
        />
        <Path
          id="LogoWave-Layer30_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M310.2 522.5Q328.35 503.8 317.15 488.9 313.35 483.85 305.35 478.2 296.65 472.5 293.65 470.1M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7"
        />
        <Path
          id="LogoWave-Layer29_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M311.2 523Q321.65 511.9 323.15 504.4 324.35 498.45 319.95 492.35 313.6 485.15 310.3 480.65 304.4 472.5 303.15 463.1M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7"
        />
        <Path
          id="LogoWave-Layer28_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M311.25 525Q322.9 517.15 324.9 510.75 326.3 506.2 322.85 499.2 318 489.5 317.15 485.55 315.2 476.15 320 465.05M181.55 632.9Q180.35 633.65 179.2 634.4 172.65 638.85 168.3 644.3 163.9 649.8 162.4 655.45 158.95 668.7 192.2 671.7"
        />
        <Path
          id="LogoWave-Layer27_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M304.65 531.15Q308.6 529.7 311.8 528.25 324.5 522.6 328.1 517.3 331.25 512.8 328.5 505.15 326.75 500.1 326.4 498.55 325.45 494.7 326.1 491.2 327.65 482.05 340.8 471.85M181.55 632.85Q180.35 633.6 179.2 634.35 172.65 638.8 168.3 644.25 163.9 649.75 162.4 655.4 158.95 668.65 192.2 671.65"
        />
        <Path
          id="LogoWave-Layer26_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7M312.75 531.3Q325.25 526.8 330.65 520.85 334.65 516.5 336.2 509.1 338.75 496.85 339.15 495.8 341.95 487.55 349.2 480.65"
        />
        <Path
          id="LogoWave-Layer25_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.85Q180.3 633.6 179.15 634.35 172.6 638.8 168.25 644.25 163.85 649.75 162.35 655.4 158.9 668.65 192.15 671.65M313.1 528.55Q333.65 519.1 337.45 506.35 340.9 494.9 332.4 472.85"
        />
        <Path
          id="LogoWave-Layer24_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7M307.2 526.65Q328.4 511.55 329.45 498.15 330.55 484.5 311.15 471.1"
        />
        <Path
          id="LogoWave-Layer23_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M310.2 522.5Q328.35 503.8 317.15 488.9 313.35 483.85 305.35 478.2 296.65 472.5 293.65 470.1M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7"
        />
        <Path
          id="LogoWave-Layer22_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M311.2 523Q321.65 511.9 323.15 504.4 324.35 498.45 319.95 492.35 313.6 485.15 310.3 480.65 304.4 472.5 303.15 463.1M181.5 632.9Q180.3 633.65 179.15 634.4 172.6 638.85 168.25 644.3 163.85 649.8 162.35 655.45 158.9 668.7 192.15 671.7"
        />
        <Path
          id="LogoWave-Layer21_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M311.25 525.05Q322.9 517.2 324.9 510.8 326.3 506.25 322.85 499.25 318 489.55 317.15 485.6 315.2 476.2 320 465.1M181.55 632.95Q180.35 633.7 179.2 634.45 172.65 638.9 168.3 644.35 163.9 649.85 162.4 655.5 158.95 668.75 192.2 671.75"
        />
        <Path
          id="LogoWave-Layer20_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M304.65 531.2Q308.6 529.75 311.8 528.3 324.5 522.65 328.1 517.35 331.25 512.85 328.5 505.2 326.75 500.15 326.4 498.6 325.45 494.75 326.1 491.25 327.65 482.1 340.8 471.9M181.55 632.9Q180.35 633.65 179.2 634.4 172.65 638.85 168.3 644.3 163.9 649.8 162.4 655.45 158.95 668.7 192.2 671.7"
        />
        <Path
          id="LogoWave-Layer19_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M320.1 528.8Q329.6 525.1 332.35 520.6 334.55 517 332.9 509.3 331.15 501.2 333.3 496.8 336.85 489.35 351.65 482.75M182.35 632.85L179.9 634.4Q172.9 639.2 168.6 645.15 165 650.1 163.6 655.45 161.5 663.4 173.05 667.15 179.25 669.15 193.65 670.45"
        />
        <Path
          id="LogoWave-Layer18_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M324.05 535.65Q334.3 530.3 336.55 525.1 338.3 521.2 335.6 513.8 332.8 506 334.35 501.35 336.9 493.45 350.65 485M182.8 632.7Q175.55 638.4 170.9 644.3 166.15 650.3 165.25 655.05 163.75 663.15 176 666.05 182.6 667.65 197.2 667.9"
        />
        <Path
          id="LogoWave-Layer17_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M328.35 548.95Q339.1 540.5 341.35 534.5 343.3 529.4 338.8 522.65 335.85 518.15 335.1 516.8 333.25 513.2 333 509.7 332.35 500.4 342.65 487.4M182.75 632.7Q175.85 638.15 171.6 644.2 167.65 649.75 166.7 654.8 165.25 662.75 177.95 664.45 182.2 665 189.25 665 193.05 664.95 199.65 664.9"
        />
        <Path
          id="LogoWave-Layer16_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M216.6 595.3Q232.3 584.7 250.9 576.55 269.45 568.45 281.3 565.45 285.7 579.55 280.15 589.45 274.6 599.3 263.2 605.55 251.75 611.75 238.05 609.75 224.4 607.8 216.6 595.3Z"
        />
        <Path
          id="LogoWave-Layer16_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M327.85 548.95Q338.35 539.85 340.35 533.75 342.05 528.55 337.25 522 334.1 517.65 333.3 516.35 331.3 512.85 330.85 509.35 329.75 500.1 339.45 486.6M182.75 632.7Q176.5 637.6 172.55 643.3 168.55 649.1 167.45 654.8 166 662.65 178.55 663.7 185.55 664.25 200.15 663.4"
        />
        <Path
          id="LogoWave-Layer15_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M216.65 595.3Q232.35 584.7 250.95 576.55 269.5 568.45 281.35 565.45 285.75 579.55 280.2 589.45 274.65 599.3 263.25 605.55 251.8 611.75 238.1 609.75 224.45 607.8 216.65 595.3Z"
        />
        <Path
          id="LogoWave-Layer15_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M185 631Q183.85 631.8 182.8 632.7 176.55 637.6 172.6 643.3 168.6 649.1 167.5 654.8 166.05 662.65 178.6 663.7 185.6 664.25 200.2 663.4M321.9 553.8Q325.2 551.25 327.9 548.95 338.4 539.85 340.4 533.75 342.1 528.55 337.3 522 334.15 517.65 333.35 516.35 331.35 512.85 330.9 509.35 329.8 500.1 339.5 486.6"
        />
        <Path
          id="LogoWave-Layer14_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M216.65 595.3Q232.35 584.7 250.95 576.55 269.5 568.45 281.35 565.45 285.75 579.55 280.2 589.45 274.65 599.3 263.25 605.55 251.8 611.75 238.1 609.75 224.45 607.8 216.65 595.3Z"
        />
        <Path
          id="LogoWave-Layer14_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M328.05 549.3L328.1 549.25Q339.25 540.95 341.65 535 343.75 529.95 339.45 523.1 336.6 518.5 335.9 517.15 334.2 513.5 334 509.95 333.6 500.7 344.25 487.95M182.8 632.7Q176.55 637.6 172.6 643.3 168.6 649.1 167.5 654.8 166.05 662.65 178.6 663.7 185.6 664.25 200.2 663.4"
        />
        <Path
          id="LogoWave-Layer13_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M328.2 548.5Q339.8 543 343.2 537.9 346.35 533.45 343.5 525.75 341.7 520.7 341.25 519.25 340.3 515.3 340.85 511.9 342.4 502.7 355.45 492.35M182.8 632.7Q175.9 638.15 171.65 644.2 167.7 649.75 166.75 654.8 165.3 662.75 178 664.45 182.25 665 189.3 665 193.1 664.95 199.7 664.9"
        />
        <Path
          id="LogoWave-Layer12_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M325.1 537.5Q338.8 531.25 341.5 525.1 343.25 521.2 340.55 513.8 337.75 506 339.3 501.35 341.85 493.45 355.6 485M182.75 632.7Q175.5 638.4 170.85 644.3 166.1 650.3 165.2 655.05 163.7 663.15 175.95 666.05 182.55 667.65 197.15 667.9"
        />
        <Path
          id="LogoWave-Layer11_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M319.4 527.8Q329.1 522.75 332.9 517.95 336.55 513.4 336 506.55 335.5 502.55 335.3 500.4 334.95 496.6 335.3 493.55 336.3 485 343.7 476.15M182.35 632.85L179.9 634.4Q172.9 639.2 168.6 645.15 165 650.1 163.6 655.45 161.5 663.4 173.05 667.15 179.25 669.15 193.65 670.45"
        />
        <Path
          id="LogoWave-Layer7_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M216.1 596.9Q231.25 584.6 249.6 574.55 267.9 564.55 279.8 560.45 285.55 574.5 280.75 585.15 275.95 595.75 264.8 603.2 253.6 610.55 239.4 609.75 225.2 609 216.1 596.9Z"
        />
        <Path
          id="LogoWave-Layer6_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M215.7 599.4Q229.6 583.65 247.25 569.8 264.9 555.95 276.8 549.5 285.35 563.65 282.1 575.9 278.85 588.15 268.35 598 257.8 607.85 242.6 609.35 227.45 610.9 215.7 599.4Z"
        />
        <Path
          id="LogoWave-Layer5_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M213.5 600.15Q227.55 581.7 245.95 564.95 264.25 548.25 276.85 540.15 287.5 554.75 284.9 568.45 282.4 582.05 271.6 593.75 260.8 605.45 244.1 608.55 227.5 611.6 213.5 600.15Z"
        />
        <Path
          id="LogoWave-Layer4_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M212.95 601.1Q226.9 581.95 245.25 564.4 263.6 547 276.3 538.4 287.45 553.15 285.1 567.1 282.8 581.05 272.1 593.25 261.3 605.45 244.35 608.95 227.45 612.45 212.95 601.1Z"
        />
        <Path
          id="LogoWave-Layer3_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M213.5 600.15Q227.55 581.7 245.95 564.95 264.25 548.25 276.85 540.15 287.5 554.75 284.9 568.45 282.4 582.05 271.6 593.75 260.8 605.45 244.1 608.55 227.5 611.6 213.5 600.15Z"
        />
        <Path
          id="LogoWave-Layer2_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M215.7 599.4Q229.6 583.65 247.25 569.8 264.9 555.95 276.8 549.5 285.35 563.65 282.1 575.9 278.85 588.15 268.35 598 257.8 607.85 242.6 609.35 227.45 610.9 215.7 599.4Z"
        />
        <Path
          id="LogoWave-Layer1_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M216.15 596.9Q231.3 584.6 249.65 574.55 267.95 564.55 279.85 560.45 285.6 574.5 280.8 585.15 276 595.75 264.85 603.2 253.65 610.55 239.45 609.75 225.25 609 216.15 596.9Z"
        />
      </Defs>
      <G id="LogoWave-Scene-1-copyt18" overflow="visible">
        <G display="none">
          <Use xlinkHref="#LogoWave-puzmowavescenet74o56d71" transform="translate(-97.55 -423.95)" />
          <animate attributeName="display" repeatCount="1" fill="freeze" dur="2.367s" keyTimes="0;.789;1" values="none;inline;inline" />
        </G>
        <G>
          <Use xlinkHref="#LogoWave-puzmowavescenet18d71" transform="translate(-97.55 -423.95)" />
          <animate attributeName="display" repeatCount="1" fill="freeze" dur="2.367s" keyTimes="0;.789;1" values="inline;none;none" />
        </G>
      </G>
    </Svg>
  )
}
